import { render, staticRenderFns } from "./DeviceOverviewRoomTargetLimitsCard.vue?vue&type=template&id=f673eca2"
import script from "./DeviceOverviewRoomTargetLimitsCard.vue?vue&type=script&lang=js"
export * from "./DeviceOverviewRoomTargetLimitsCard.vue?vue&type=script&lang=js"
import style0 from "./DeviceOverviewRoomTargetLimitsCard.vue?vue&type=style&index=0&id=f673eca2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports